import React from "react";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import DialpadIcon from "@mui/icons-material/Dialpad";
import swal from "sweetalert";
import { useState } from "react";

import { makePostRequest } from "../../../utils/utils";

function SendOtp() {
  const navigate = useNavigate();
  const [verificationCode, setVerificationCode] = useState();
  const [otpErrorMsg,setOtpErrorMessage]=useState("");

 async function handleChangeVerificationCode(otp)
 {
  setOtpErrorMessage("");
  const regex = /^[0-9\b]+$/;
  // alert(otp.length);
    if(regex.test(otp) && otp.length===4)
      setVerificationCode(otp);
    else
      setOtpErrorMessage("Invalid OTP , Please enter correct OTP");
    
    
 }


  async function verifyVerificationCode()
  {
        setOtpErrorMessage("");
          //  localStorage.setItem('forgetEmail',forgetEmail);

          if(verificationCode)
          {
           var inputdata = {
            email_id: localStorage.getItem('forgetEmail'),
            verification_code:verificationCode
          };
        await makePostRequest("resident/verify/resetPasswordWeb", inputdata)
            .then(async (response) => {
              console.log('Otp Response ',response);
              if (response.data.data) {
                console.log(response);
                localStorage.setItem('verificationCode',verificationCode)
                swal( "Code Verified", "Set New Password", "success",{
                  timer: 3000,
                  buttons: false,
                });
                navigate("/ChangePassword")

              }

            })
            .catch((err) => {
              setOtpErrorMessage("Invalid OTP , Please enter correct OTP");
            });
          }
          else
          {
            setOtpErrorMessage("Please enter OTP");
          }


  }

  return (
    <>
      <div className="loginwrapper">
        <div className="loginLeft" id="logAndForgot">
          <div className="loginBox" id="">
            <h2>ResiPro</h2>
            <div className="loginInner">
              <div className="bottSection">
                {/* <h3>Enter OTP</h3> */}
                <h5>Please Enter OTP</h5>
                <Input
                   type="text"
                  placeholder="OTP"
                  inputProps={{ maxLength: 4 }}
                  className="myInput"
                  onChange={(e)=>handleChangeVerificationCode(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <DialpadIcon />
                    </InputAdornment>
                  }
                />
                 <div className="errorField errorFieldFForLogin">
                  {otpErrorMsg}
                </div>
                <Button
                  variant="contained"
                  className="logButton"
                  onClick={() =>verifyVerificationCode() }
                >
                  Reset
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SendOtp;
